import api from "./api";
import axios from "axios";
import { getUser, setUser } from "../services/Auth";

export const SetarTokenFirebase = async (token) => {
  try {
    const usuario = await getUser();
    if (token) {
      await api.put(`/usuarios/${usuario._id}`, { token_firebase: token });
    } else {
      throw new Error("Token nulo");
    }
  } catch (error) {
    throw error;
  }
};

export const EditarInformacoes = async (data) => {
  try {
    const user = await getUser();
    if (user) {
      const update = await api.put(`/estabelecimentos/${user.estabelecimento._id}`, data);
      user.estabelecimento = update.data;
      setUser(user);
      return update.data;
    }
  } catch (error) {
    throw error;
  }
};

export const EditarSenha = async (senha) => {
  try {
    const user = await getUser();
    if (user) {
      const update = await api.put(`/usuarios/${user._id}`, { senha: senha });
      return update;
    }
  } catch (error) {
    throw error;
  }
};

export const getInfoFinanceiraEstabelecimento = async () => {
  try {
    const usuario = await getUser();

    const info = await api.get(
      `/info-financeira/estabelecimento/${usuario.estabelecimento._id}`,
    );
    return info.data[0];
  } catch (error) {
    throw error;
  }
};

export const MudarStatusEstabelecimento = async (status) => {
  try {
    const usuario = await getUser();
    const stab = await api.put(`/estabelecimentos/${usuario.estabelecimento._id}`, {
      status: status,
    });
    usuario.estabelecimento = stab.data;
    await setUser(usuario);
    return stab.data;
  } catch (error) {
    throw error;
  }
};

export const listarCartao = async () => {
  try {
    const cartoes = await api.get(`/cartoes-estabelecimentos`);
    return cartoes.data;
  } catch (error) {
    throw error;
  }
};

export const listarCartaoAceito = async () => {
  try {
    let usuario = await getUser();
    const cartoes = await api.get(
      `/estabelecimentos/${usuario.estabelecimento._id}/cartoes-aceitos`,
    );
    return cartoes.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarFotos = async (data) => {
  try {
    let usuario = await getUser();
    const fotos = await api.post(
      `/estabelecimentos/${usuario.estabelecimento._id}/informacoes-adicionais/fotos`,
      data,
    );
    return fotos.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarCartao = async (data) => {
  try {
    let usuario = await getUser();
    const cartoes = await api.post(
      `/estabelecimentos/${usuario.estabelecimento._id}/cartoes-aceitos`,
      data,
    );
    return cartoes.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarInformacao = async (data) => {
  try {
    let usuario = await getUser();
    const info = await api.post(
      `/estabelecimentos/${usuario.estabelecimento._id}/informacoes-adicionais`,
      data,
    );
    usuario.estabelecimento = info.data;
    await setUser(usuario);
    return info.data;
  } catch (error) {
    throw error;
  }
};

export const getCEP = async (cep) => {
  try {
    const res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const ListarEstabelecimentos = async (page) => {
  try {
    const estabelecimentos = await api.get(`/estabelecimentos?page=${page}`);
    return estabelecimentos.data;
  } catch (error) {
    throw error;
  }
};

export const getInformacao = async () => {
  try {
    let usuario = await getUser();
    const info = await api.get(`/estabelecimentos/${usuario.estabelecimento._id}`);

    return info.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarDinheiro = async (data) => {
  try {
    let usuario = await getUser();
    const dinheiro = await api.put(`/estabelecimentos/${usuario.estabelecimento._id}/`, {
      metodo_pagamento: {
        ...usuario.estabelecimento.metodo_pagamento,
        ...data,
      },
    });
    usuario.estabelecimento = dinheiro.data;
    await setUser(usuario);
    return dinheiro.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarCartao = async (id) => {
  try {
    let usuario = await getUser();
    if (usuario && usuario.estabelecimento) {
      if (typeof usuario.estabelecimento._id !== "undefined") {
        const cartao = await api.delete(
          `estabelecimentos/${usuario.estabelecimento._id}/cartoes-aceitos/${id}`,
        );
        return cartao.data;
      }
    }
  } catch (error) {
    throw error;
  }
};

const downloadExcelFile = (data, filename) => {
  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", filename + ".xlsx");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const DownloadExcelAtualizacaoPrecos = async () => {
  try {
    const usuario = await getUser();
    const response = await api.get(
      `/estabelecimentos/${usuario.estabelecimento._id}/download-excel-atualizacao-precos`,
      {
        responseType: "blob",
      },
    );
    downloadExcelFile(response.data, "ifeira-planilha-precos");
  } catch (error) {
    throw error;
  }
};

export const UploadExcelAtualizacaoPrecos = async (formData) => {
  try {
    const usuario = await getUser();
    const response = await api.post(
      `/estabelecimentos/${usuario.estabelecimento._id}/upload-excel-atualizacao-precos`,
      formData,
      {
        responseType: "blob",
      },
    );
    return null;
  } catch (error) {
    if (error instanceof Blob) {
      downloadExcelFile(error, "ifeira-planilha-precos-erro");
      throw new Error("planilha mal preenchida");
    }
    throw error;
  }
};
